import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafSkeletonLoader } from '@esi/leaf-web/lib/wc';
import '@esi/leaf-web/lib/wc/components/skeleton-loader/skeleton-loader';

@Component({
  selector: 'cigna-leaf-skeleton-loader',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-skeleton-loader
      [variant]="variant"
      [height]="height"
      [width]="width"
    ></leaf-skeleton-loader>
  `,
})
export class CignaLeafSkeletonLoaderComponent {
  @Input() variant: LeafSkeletonLoader['variant'] = 'rectangle';
  @Input() height: LeafSkeletonLoader['height'];
  @Input() width: LeafSkeletonLoader['width'];
}
